import React from "react";

const buildVisiblePages = (currentPage, totalPages) => {
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  if (currentPage <= 3) {
    return [1, 2, 3, 4, "end-ellipsis", totalPages];
  }

  if (currentPage >= totalPages - 2) {
    return [1, "start-ellipsis", totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  }

  return [
    1,
    "start-ellipsis",
    currentPage - 1,
    currentPage,
    currentPage + 1,
    "end-ellipsis",
    totalPages,
  ];
};

function Pagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) {
    return null;
  }

  const pages = buildVisiblePages(currentPage, totalPages);

  return (
    <nav className="cp-pagination" aria-label="Product pagination">
      <button
        type="button"
        className="cp-pagination__button"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        Previous
      </button>

      <div className="cp-pagination__pages">
        {pages.map((page, index) =>
          typeof page === "number" ? (
            <button
              key={page}
              type="button"
              className={
                page === currentPage
                  ? "cp-pagination__button is-active"
                  : "cp-pagination__button"
              }
              aria-current={page === currentPage ? "page" : undefined}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          ) : (
            <span
              key={`${page}-${index}`}
              className="cp-pagination__ellipsis"
              aria-hidden="true"
            >
              ...
            </span>
          ),
        )}
      </div>

      <button
        type="button"
        className="cp-pagination__button"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        Next
      </button>
    </nav>
  );
}

export default Pagination;
